import { Outlet } from "react-router-dom";
import { AnalyticsFiltersProvider } from "./providers/analytics-filters.provider";

export default function AnalyticsLayout() {
  return (
    <AnalyticsFiltersProvider>
      <Outlet />
    </AnalyticsFiltersProvider>
  );
}
